import { useCallback, useRef, useMemo } from 'react'
import cn from 'classnames'

import { useModal } from '../../../hooks/use-modal'
import { Input } from '../input'

import RiskMatrixModal from './risk-matrix-modal'

import s from './risk-matrix-picker.module.scss'
import {
  ISafetyCaseRiskMatrix,
  ISafetyCaseRiskMatrixCell,
} from '../../../interfaces/services/safety-case-risk-matrix'

interface RiskMatrixPickerProps {
  data: ISafetyCaseRiskMatrix
  value?: ISafetyCaseRiskMatrixCell
  name?: string
  placeholder?: string
  onChange: (value: ISafetyCaseRiskMatrixCell) => void
  disabled?: boolean
  isViewMode?: boolean
  isInvalid?: boolean
}

const RiskMatrixPicker: React.FC<RiskMatrixPickerProps> = props => {
  const { data, value, name, placeholder, onChange, disabled, isViewMode, isInvalid } = props

  const { isOpen, closeModal, openModal } = useModal()

  const colorPaletteRef = useRef<HTMLDivElement>(null)

  const previewStyles = useMemo<React.CSSProperties>(() => ({ backgroundColor: value?.riskColor }), [value?.riskColor])

  const handlePreviewClick = useCallback(() => {
    if (disabled) {
      return
    }
    openModal()
  }, [disabled, openModal])

  const inputClassNames = cn('form-control cursor-pointer', {
    'border-danger': isInvalid,
    [s['input-view']]: isViewMode,
  })

  return (
    <>
      <div className={s['color-picker-wrapper']} ref={colorPaletteRef} onClick={handlePreviewClick}>
        <div className={cn(s['color-preview'], value?.riskColor && s['color-preview-border'])} style={previewStyles} />

        <Input
          value={value?.riskLabel || ''}
          name={name}
          placeholder={placeholder}
          isViewMode={isViewMode}
          disabled={disabled}
          readOnly
          className={inputClassNames}
        />
      </div>

      <RiskMatrixModal
        selectedCell={value}
        data={data}
        onChange={cell => {
          onChange(cell)
          closeModal()
        }}
        isOpen={isOpen}
        closeModal={closeModal}
      />
    </>
  )
}

export default RiskMatrixPicker
